export const phrases = {
  heading_settings_sort: "Sortowanie listy pracowników",
  body_settings_sort: "Sortuj listę pracowników według imienia lub nazwiska.",
  since_o_clock: "Od zegara {time}",
  old_data_warning_my_area: "Nie mogliśmy załadować żadnych nowych informacji. Upewnij się, że masz połączenie z Internetem.",
  no_data_warning_my_area: "Upewnij się, że masz połączenie z Internetem i spróbuj ponownie.",
  no_data_available_my_area: "Nie można załadować żadnych danych",
  last_update_data: "Ostatnia aktualizacja",
  something_went_wrong_absences: "Coś poszło nie tak. Spróbuj ponownie w późniejszym terminie.",
  something_went_wrong_with_the_pin_entry: "Coś poszło nie tak z wprowadzeniem kodu PIN...",
  pin_must_be_four_digits: "Kod PIN musi składać się z dokładnie czterech cyfr.",
  pins_do_not_match: "Wprowadzone kody PIN nie są zgodne.",
  pin_is_not_numerical: "Kod PIN może składać się wyłącznie z cyfr.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Wytłoczyć",
  finish_break: "Przerwa końcowa",
  finish_loading_time: "Końcowy czas ładowania",
  finish_driving_time: "Końcowy czas prowadzenia pojazdu",
  finish_business_trip: "Koniec służby",
  finish_project_as_task: "Zakończ projekt",
  finish_special_one: "End special1",
  finish_special_two: "End Special2",
  you_clockout: "Stemplujesz się.",
  sentence_work_time: "Pracujesz. | Pracujesz w tej chwili.",
  sentence_break: "Robisz sobie przerwę. | Robisz sobie przerwę.",
  sentence_loading_time: "Zapisujesz właśnie czas ładowania. Hauruck! | Właśnie rejestrujesz czas ładowania. Szarpnięcie!",
  sentence_business_trip: "Serwis zalogowany. Bawcie się dobrze!",
  sentence_driving_time: "Rezerwujesz czas na jazdę. Zapnij pasy i jedź! | Rezerwujesz czas podróży. Zapnij pasy i jedź!",
  sentence_special_one: "Dokonujesz rezerwacji specjalnej 1. | rezerwujesz specjalne 1.",
  sentence_special_two: "Rezerwujesz Special 2. | Rezerwujesz Special 2.",
  sentence_custom_time: "Rezerwujesz | Rezerwujesz",
  you_are_booked_in_activity: "Stempel {activity}! | You stamp {activity}!",
  substitute_warning: "{ days } W przypadku nieobecności trwającej kilka dni lub dłużej należy wyznaczyć zastępcę.",
  substituted_by: "Reprezentowany przez",
  name_clocked_in: "{name} wytłoczony",
  /************************************/
  //Signature stuff:

  signature: "Podpis",
  please_sign: "Proszę podpisać",
  signature_with_date: "Podpis ze strony {date}",
  signature_with_date_with_name: "Podpis {date} z {name}",
  signature_with_date_with_location: "Podpis {date} w {location}",
  signature_with_date_with_name_with_location: "Podpisanie {date} z {name} w {location}",
  signature_with_name: "Podpis: {name}",
  signature_with_name_with_location: "Podpis {name} w {location}",
  signature_with_location: "Podpis w {location}",
  /*************************************/

  accept_terms_and_conditions: "Wysyłając formularz akceptujesz nasze {agb} oraz naszą {datenschutzerklaerung}.",
  what_is_your_name: "Jak masz na imię?",
  your_email: "Twój adres e-mail",
  what_is_your_company_name: "Jak nazywa się twoja firma?",
  what_do_you_want_to_do_with_clockin: "Co chcesz zrobić z clockinem?",
  almost_finished: "Prawie tam",
  test_clockin_for_amount_period: "Wypróbuj clockin {amountOfDaysTestPeriod} za darmo przez kilka dni!",
  code_needed_to_connect: "Użyj swojego kodu",
  you_have_no_company_code: "Nie masz kodu? Skontaktuj się z osobą w swojej firmie.",
  connect_your_device: "Podłącz swoje urządzenie!",
  please_type_in_device_id: "Podaj identyfikator urządzenia, który znajdziesz pod hasłem urządzenia mobilne na naszej stronie internetowej.",
  new_at_clockin: "Jesteś nowy?",
  pin_repeat: "Powtórzenie kodu PIN",
  configure_your_pin: "Ustaw 4-cyfrowy kod PIN",
  configure_your_pin_text: "PIN jest potrzebny, aby uzyskać dostęp do osobistego obszaru na terminalu tabletu.",
  congratulations: "Gratulacje!",
  start_now: "Zacznij teraz",
  device_name_info: "Możesz zmienić nazwę urządzenia mobilnego, aby móc śledzić kilka urządzeń. Przykład: \"Smartphone MaxMustermann\". Nazwę można zmienić również w późniejszym czasie.",
  select_project: "Wybierz projekt",
  select_time: "Wybierz czas",
  create_new_account: "Utwórz nowe konto",
  join_my_company: "Dołącz do mojej firmy",
  join_clockin_with_qr: "Dołącz za pomocą kodu QR",
  change_project: "Projekt zmian",
  my_messages: "Moje wiadomości",
  my_documents: "Moje dokumenty",
  my_data_and_passwords: "Moje dane i hasła",
  my_account_data: "Moje dane",
  change_my_password: "Zmiana hasła",
  forgot_password: "Nie znam swojego hasła.",
  open_camera: "Otwarta kamera",
  scan_now: "Skanuj teraz",
  sync_now: "Zsynchronizuj teraz",
  clear_logs: "Puste dzienniki",
  saveAndGoBack: "Zapisz i wróć",
  full_day: "Cały dzień",
  activate_scanner: "Skaner jest aktywny",
  scanner_is_inactive: "Skaner nieaktywny",
  change_project_by_scan_qr: "Zeskanuj kod QR projektu, na który chcesz się przełączyć.",
  scan_device_by_qr: "Zeskanuj kod QR z urządzenia, z którego chcesz skorzystać.",
  no_access_to_camera_please_connect_device_manually: "Niestety nie udało się uzyskać dostępu do kamery, proszę wpisać ręcznie kod urządzenia.",
  no_access_to_camera_please_clockin_manually: "Niestety nie udało się uzyskać dostępu do aparatu, proszę o ręczne wbicie pieczątki.",
  qr_code_login: "Rejestracja za pomocą kodu QR",
  scan_to_login: "Zeskanuj swój kod QR, aby się zalogować.",
  checklist_was_saved: "Lista kontrolna została zapisana",
  question_save_changes_short: "Zapisać zmiany?",
  question_save_changes: "Czy chcesz zapisać zmiany?",
  question_delete_checklist_short: "Skasować listę kontrolną?",
  question_delete_checklist: "Czy na pewno chcesz usunąć listę kontrolną?",
  checklist_is_sending: "Lista kontrolna zostanie wysłana",
  checklist_sent_successfully: "Lista kontrolna wysłana pomyślnie 🎉",
  checklist_could_not_be_sent: "Nie można wysłać listy kontrolnej, spróbuj ponownie później.",
  checklist_transmission_problems_in_the_past: "W przeszłości występowały problemy z przesyłaniem niektórych plików.",
  checklist_send_with_potential_data_loss: "Czy chcesz spróbować wysłać listę kontrolną bez tych plików?",
  documentation_is_sending: "Dokumentacja projektowa jest wysyłana",
  documentation_sent_successfully: "Dokumentacja projektu została pomyślnie wysłana 🎉",
  confirm_documentation_dismissal: "Czy naprawdę chcesz wyrzucić dokumentację?",
  discard_unsaved_changes: "Chcesz wyrzucić swoje zmiany?",
  documentation_will_be_sent_when_online: "Dokumentacja zostanie wysłana, gdy tylko ponownie będziesz online.",
  confirmation_is_sending: "Potwierdzenie projektu jest wysyłane",
  ask_for_geo_permission: "Ta aplikacja potrzebuje twojej lokalizacji, " + "ale nie ma na to pozwolenia.\n\n" + "Czy chcesz otworzyć ustawienia?",
  all_projects: "Wszystkie projekty",
  half_day: "Pół dnia",
  start_end: "W zależności od czasu",
  my_area: "Mój obszar",
  my_area_video_teaser_clockin_explained_by_frederik: "zegar wyjaśniony przez Freddi",
  add_time: "Tworzenie czasu",
  show_times_in_confirmation: "Godziny pokazów w potwierdzeniu",
  change_time: "Czas zmiany",
  finish_project: "Projekt gotowy",
  finish_project_date: "Finalizacja spotkania",
  unfinish_project: "Ponowne otwarcie projektu",
  unfinish_project_date: "Ponowne otwarcie spotkania",
  absence_overview: "Zarządzaj nieobecnościami",
  edit_absence: "Edycja nieobecności",
  edited_absence: "Nieobecność zredagowana",
  created_absence: "Pomyślnie utworzono wniosek o urlop",
  creating_absence: "Wniosek o urlop został utworzony",
  error_creating_absence: "Błąd podczas tworzenia żądania nieobecności",
  create_absence: "Tworzenie nieobecności",
  deleted_absence: "Wniosek o wycofanie nieobecności",
  new_request: "Nowy wniosek",
  your_requests: "Twoje aplikacje",
  planned_days: "Zaplanowane dni",
  planned_hours: "Zaplanowane godziny",
  used_days: "Wykorzystane dni",
  used_hours: "Spędzone godziny",
  free_days: "Dni wolne",
  free_hours: "Godziny urlopu",
  open_days: "Dni otwarte",
  open_hours: "Godziny otwarcia",
  withdraw_request: "Wycofanie wniosku",
  change_request: "Wniosek o zmianę",
  request_was_approved: "Twój wniosek został zatwierdzony",
  request_is_pending: "Twój wniosek nie został jeszcze zatwierdzony",
  request_was_rejected: "Twój wniosek został odrzucony",
  add_attachment: "Dodaj załącznik",
  message_optional: "Komunikat (opcjonalnie)",
  filed_on: "Zgłoszono dnia",
  this_year: "W tym roku",
  search_sub_projects: "Nad którym podprojektem chciałbyś pracować?",
  error_occurred: "Wystąpił błąd, spróbuj ponownie później.",
  re_record: "Usunąć i nagrać to wideo ponownie?",
  delete_video: "Usunąć nagranie?",
  no_results_found: "Nie znaleziono wyników",
  record_again: "Ponów próbę",
  request_valid_email: "Proszę wpisać prawidłowy adres e-mail.",
  request_valid_company_name: "Proszę wpisać poprawną nazwę firmy.",
  request_valid_first_name: "Proszę wpisać prawidłowe imię.",
  request_valid_last_name: "Proszę wprowadzić prawidłowe nazwisko.",
  total_duration_today: "Całkowity czas dzisiaj",
  show_daily_protocol: "Pokaż dziennik",
  change_profile_pic: "Zmień zdjęcie profilowe",
  logout_account: "Rozłączenie konta",
  you_are_working: "Pracujesz teraz!",
  you_are_taking_a_break: "Masz przerwę!",
  activity_edited: "Czynność zredagowana",
  activity_edited_undo: "Przetwarzanie zostało pomyślnie cofnięte",
  activity_edited_missing_project: "Projekt wciąż nie został zrealizowany!",
  activity_deleted: "Aktywność usunięta",
  activity_deleted_undo: "Przywrócono usuniętą aktywność",
  activity_created: "Utworzono nową aktywność",
  activity_created_undo: "Nowo utworzona aktywność została wycofana",
  correct_working_hours: "Prawidłowe czasy pracy",
  your_changes_are_being_saved: "Zmiany zostały zapisane.",
  manage_working_hours: "Zarządzanie godzinami pracy",
  delete_activity: "Usunięcie aktywności",
  start_navigation: "Rozpocznij nawigację",
  no_valid_email: "Wprowadzony adres e-mail jest nieprawidłowy.",
  delete_checklist: "Usuń listę kontrolną",
  active_checklists: "Aktywne listy kontrolne",
  scan_qr_code: "Zeskanuj kod QR",
  switch_to_office_center: "Przejście do centrum biurowego",
  confirm_project_completion_short: "Projekt gotowy",
  confirm_project_date_completion_short: "Finalizacja spotkania",
  project_completed: "Projekt zakończony!",
  project_date_completed: "Nominacja sfinalizowana!",
  confirm_project_uncompletion_short: "Ponowne otwarcie projektu",
  confirm_project_date_uncompletion_short: "Ponowne otwarcie spotkania",
  project_uncompleted: "Projekt aktywowany",
  project_date_uncompleted: "Data aktywacji",
  choose_project: "Wybierz projekt",
  choose_sub_project: "Wybierz podprojekt",
  choose_site: "Wybierz lokalizację",
  active_projects: "Aktywne projekty",
  completed_term: "ukończony",
  completed_projects: "Ukończone projekty",
  end_of_work: "Miłego wieczoru",
  correct_time: "Prawidłowy czas",
  you_stamp_x: "Ty stemplujesz",
  enter_pin: "Proszę wprowadzić PIN",
  wrong_pin: "Nieprawidłowe wprowadzenie kodu PIN",
  pin_change_required: "Zostałeś poproszony o zmianę kodu PIN",
  enter_new_pin: "Wprowadź nowy kod PIN",
  approve_pin: "Potwierdź PIN",
  no_projects_scheduled: "Dla {day} Żadne projekty nie są przechowywane.",
  you_clock_in_project: "Od tej pory zapisujesz czas pracy nad projektem.",
  project_scan_error: "Ten kod nie jest ważny dla żadnego projektu.",
  show_more_days: "pokaż więcej dni",
  show_more_times: "Pokaż więcej razy",
  only_show_today: "Pokaż tylko dzisiaj",
  todays_total_time: "Całkowity czas dzisiaj",
  everything_synced: "Twoje dane są aktualne!",
  upload_in_progress: "Dane są przesyłane...",
  who_are_you: "Kim jesteś?",
  is_uploading_to_server: "Twoje zmiany są przekazywane do centrum biurowego.",
  offline_and_data_is_stored_locally: "Twoje zmiany zostaną wkrótce przeniesione do centrum biurowego. ",
  show_more: "wykazać więcej",
  activity_edited_wrong_date: "Wprowadziłeś złą datę.",
  confirm_logout: "Czy naprawdę chcesz się wypisać?",
  confirm_clockout: "Jesteś pewien, że chcesz zakończyć pracę na dziś?",
  gps_is_active: "Przesyłane są dane GPS",
  location_tracking_is_active: "Aby włączyć śledzenie GPS.",
  app_settings: "Ustawienia aplikacji",
  clock_reminder: "Pieczątka – Przypomnienie",
  mon_to_fri: "Standardowe: poniedziałki - piątki",
  logout: "Rozłączenie konta",
  refresh: "Aktualizacja",
  prompt_language_settings: "Tutaj ustaw język aplikacji.",
  prompt_clock_reminder: "Przypomnienie za pomocą powiadomienia push, aby dopasować się do codziennej pracy.",
  register_company: "Zarejestruj firmę",
  use_code: "Użyj kodu",
  our_customers: "Nasi klienci",
  free_test_now: "Test teraz bezpłatny",
  tier_attendance: "Rejestruję tylko godziny pracy i przerwy.",
  tier_documentation: "Chcę również zarezerwować godziny pracy nad projektami, którymi zarządzam w clockin.",
  your_tier: "Twój pakiet",
  all_clockin_functions: "Wszystkie funkcje zegara",
  checklists_formulars: "Listy kontrolne i funkcje",
  projectfile_incl_chat: "Cyfrowe pliki projektu (w tym czat)",
  photo_sketch_note: "Funkcja zdjęć, szkiców i notatek",
  digital_signature: "Podpisy cyfrowe",
  datev_connection: "Połączenie DATEV",
  calendar_absences: "Zarządzaj kalendarzem i nieobecnościami",
  individual_design: "Wygląd indywidualny",
  attendance_time_tracking: "Stacjonarna rejestracja czasu pracy za pomocą terminalu tabletu",
  mobile_time_tracking: "Mobilna rejestracja czasu pracy za pomocą aplikacji na smartfony",
  browser_time_tracking: "Nagrywanie czasu pracy przeglądarki na komputerze dla biura domowego",
  help_use_code: "Proszę wpisać kod, który znajduje się w centrum biurowym w zakładce urządzenia mobilne/pracownicy.",
  wrong_code: "Nieprawidłowy kod",
  wrong_code_text: "Kod nie jest ważny. Proszę spróbować ponownie z ważnym kodem.",
  wrong_code_text_short: "Kod jest nieprawidłowy",
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: "Nieprawidłowy kod QR",
  invalid_qr_code_text: "Zeskanowany kod QR jest nieprawidłowy. Zeskanuj prawidłowy kod zegara.",
  code_already_connected: "Za pomocą tego kodu można podłączyć urządzenie. Ale jesteś już połączony.",
  wrong_credentials: "Nieprawidłowe dane dostępu",
  wrong_credentials_text: "Wprowadzona kombinacja adresu e-mail i hasła nie została znaleziona. Sprawdź wprowadzone dane i spróbuj ponownie.",
  new_pin: "Wprowadź nowy kod PIN",
  choose_next_action: "Wybierz swoje następne działanie",
  name_of_software_package: "Nazwa pakietu oprogramowania",
  select_teamleader: "Kto pieczętuje drużynę?",
  select_teamleader_description: "Aby kontynuować stemplowanie, wybierz osobę, która przejmie kontrolę nad urządzeniem.",
  clocked_in_on_this_device: "Stempel na tym urządzeniu",
  not_clocked_in_on_this_device: "Nie wytłoczono na tym urządzeniu",
  select_new_teamleader: "Kto powinien teraz stemplować drużynę?",
  switch_teamleader: "Przekazanie jednostki",
  just_me: "Właśnie kończę pracę",
  select_the_new_teamleader: "Ustalenie nowego lidera zespołu",
  back_to_selection: "powrót do wyboru",
  manage_team: "Zarządzaj zespołem",
  total_time_team: "Całkowity czas zespołu",
  count_members_clocked_in: "{clockedin}/{members} Członkowie zespołu ostemplowani w",
  whole_team: "Cały zespół",
  teammembers_still_clockedin: "Wybierz, czy chcesz odblokować tylko siebie, czy wszystkich członków zespołu?",
  clockout_all: "Wytępić wszystkie",
  select_employee: "Najpierw wybierz użytkownika",
  something_went_wrong: "Coś poszło nie tak, proszę spróbować ponownie później.",
  new_pin_successfully_changed: "PIN zmieniony pomyślnie",
  enter_pin_before_clockin_prompt: "Najpierw wprowadź po kolei swój PIN, aby się zalogować.",
  enter_pin_before_clockout_prompt: "Najpierw należy wprowadzić PIN pojedynczo, aby się wykręcić.",
  delete_activity_alert_title: "Usunięcie aktywności",
  delete_activity_alert_msg: "Czy na pewno chcesz usunąć tę aktywność?",
  delete_absence_message: "Czy na pewno chcesz wycofać wniosek?",
  delete_absence_title: "Wycofanie wniosku",
  are_you_sure: "Jesteś pewien?",
  request_password: "Żądanie nowego hasła",
  password_requested: "Link do nowego hasła został wysłany na Twój adres e-mail.",
  no_email_retrieved: "Nie otrzymałeś wiadomości e-mail? Sprawdź folder spamu lub spróbuj ponownie.",
  name_of_customer: "Nazwa klienta",
  missing_permissions_homepage_text: "Nie masz uprawnień do zmiany aktywności na tym urządzeniu. Skontaktuj się z administratorem, aby uzyskać dostęp.",
  no_permission_warning_my_area: "Nie masz uprawnień dostępu do tego obszaru. Skontaktuj się z administratorem, aby uzyskać dostęp.",
  employee_clocked_in: "{name} zarejestrowany!",
  employee_clocked_out: "{name} wylogowany!",
  no_employee_to_qr_code_warning: "Nie udało się znaleźć pracownika dla tego kodu QR.",
  no_employees_registered_heading: "Żaden pracownik nie został jeszcze przydzielony do tej jednostki.",
  no_employees_registered_body: "W centrum biurowym w ustawieniach urządzenia mobilnego można przypisać pracowników, którzy będą mogli rejestrować swój czas pracy na tym urządzeniu.",
  no_employee_found: "Niestety nie udało się znaleźć nikogo o tym imieniu.",
  no_employee_assigned: "Nie przydzielono żadnego pracownika",
  you_need_help: "Potrzebujesz pomocy?",
  here_you_can_get_help_to_register_employees_for_device: "Tutaj znajdziesz wszystkie informacje na temat przypisywania pracowników do jednostek.",
  show_time: "Tworzenie czasu",
  export_timesheet: "Eksportuj timesheet",
  select_month: "Wybierz miesiąc",
  internet_connection_required: "W tym celu wymagane jest połączenie z Internetem.",
  select_an_activity_to_clockin_your_team: "Wybierz aktywność do ostemplowania w swoim zespole.",
  confirm_uploading_sqlite_for_debugging: "Czy na pewno chcesz przesłać dane w aplikacji do obsługi Clockin?",
  no_tasks_available: "Brak dostępnych zadań",
  click_to_add_tasks: "Kliknij, aby dodać zadania",
  scan_nfc_tag: "Proszę przyłożyć kartę do czytnika.",
  link_nfc_tag: "Połącz tag NFC",
  select_employee_for_nfc_tag: "Wybierz pracownika, który ma połączyć ten tag NFC:",
  nfc_tag_linked_successfully: "Pomyślnie posłużono się tagiem NFC z {name} Połączone.",
  nfc_linking_failed: "Nie można połączyć tagu NFC. Spróbuj ponownie.",
  nfc_not_enabled: "Funkcja NFC nie jest obsługiwana przez to urządzenie lub jest wyłączona.",
  nfc_initialization_failed: "Niestety, coś poszło nie tak. Spróbuj ponownie.",
  nfc_scan_failed: "Niestety, coś poszło nie tak. Spróbuj ponownie.",
  nfc_no_tag_found: "Nie znaleziono tagu NFC.",
  nfc_tag_already_linked_to: "Ten tag NFC jest już dostępny z {name} Połączone.",
  nfc_scan_active: "Skanowanie NFC aktywne",
  nfc_linking_enabled: "Tagi NFC można teraz łączyć. Przytrzymaj teraz tag NFC, aby połączyć go z czytnikiem NFC.",
  nfc_all_employees_linked: "Wszyscy pracownicy przypisani do tego urządzenia zostali już połączeni.",
  no_employee_to_nfc_warning: "Nie znaleziono żadnego pracownika dla tego tagu NFC.",
  select_employee_to_link_nfc: "Z kim powinien być powiązany tag NFC?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Witamy w Clockin",
        clocking_time: "Czasy na torze",
        push_notifications: "Nie zapomnij niczego"
      },
      text: {
        clocking_time: "Zegar jest punktem wyjścia do każdej aktywności. Ty zajmujesz się swoją pracą, aplikacja zajmuje się dokumentacją.",
        push_notifications: "Teraz włącz powiadomienia. Clockin przypomina, jeśli zapomnisz znaczka i upewnia się, że wszystko ważne otrzymasz od razu."
      },
      button: {
        lets_go: "Rozpocznij teraz"
      }
    },
    my_area: {
      heading: {
        my_area: "Mój obszar",
        absences: "Nieobecności i wnioski",
        settings: "Ustawienia osobiste"
      },
      text: {
        my_area: "Centralne miejsce, w którym masz natychmiastowy przegląd swoich godzin pracy i nadgodzin. Z tego miejsca można zarządzać godzinami pracy, uzyskać dostęp do dziennika, przesyłać wnioski i przeglądać swój czas pracy.",
        absences: "Zarządzaj wnioskami urlopowymi, dniami chorobowymi i innymi nieobecnościami. Zawsze śledź status swoich wniosków i przesyłaj nowe szybko i łatwo za pomocą kilku kliknięć.",
        settings: "Wysyłaj wiadomości do firmy lub zmieniaj ustawienia osobiste, a jeśli chcesz zmienić hasło, możesz to zrobić również tutaj!"
      },
      button: {
        lets_go: "Zacznij"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Ponieważ liczy się Twój czas",
        clock_in: "Pieczęć w",
        switch_task: "Zmiana pieczęci",
        clock_out: "Wytłoczyć",
        thats_it: "To wszystko!"
      },
      text: {
        your_time_matters: "Dzięki funkcji clockin pomagamy skoncentrować się na tym, co najważniejsze. Rejestruj swój czas pracy jednym kliknięciem.",
        clock_in: "Wystarczy jedno kliknięcie, aby bezpośrednio zalogować się do systemu. Clockin automatycznie zapisuje dane, dzięki czemu wszystko jest zawsze widoczne.",
        switch_task: "Masz inny projekt, robisz sobie przerwę lub idziesz na następne spotkanie? Wystarczy ponownie oznaczyć swoją nową aktywność. Reszta jest rejestrowana automatycznie.",
        clock_out: "I jednym kliknięciem jesteś wyeliminowany.",
        thats_it: "Zrobiłeś to i jesteś gotowy do rejestrowania swojego czasu pracy. Jeśli potrzebujesz pomocy, po prostu skontaktuj się z nami. Z clockin wszystko jest proste - łącznie z komunikacją z nami."
      },
      button: {
        your_time_matters: "Pokaż mi, jak to się robi",
        thats_it: "Rozpocznij teraz"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Ponieważ liczy się Twój czas",
        clock_in: "Pieczęć w",
        clock_in_team: "Zespół odprawy",
        switch_task: "Zmiana pieczęci",
        change_teamleader: "Przekazanie jednostki",
        clock_out: "Wytłoczyć",
        thats_it: "To wszystko!"
      },
      text: {
        your_time_matters: "Dzięki funkcji clockin pomagamy skoncentrować się na tym, co najważniejsze. Rejestruj godziny pracy swojego zespołu jednym kliknięciem.",
        clock_in: "Wybierz osobę, która odmierza czas dla zespołu, a jednym kliknięciem zostaniesz bezpośrednio zalogowany. Aplikacja clockin automatycznie zapisuje dane, dzięki czemu możesz mieć wszystko na oku przez cały czas.",
        clock_in_team: "Po prostu stempluj swój zespół bezpośrednio. Niezależnie od tego, czy wszyscy jednocześnie, czy tylko poszczególni członkowie.",
        switch_task: "Masz inny projekt, robisz sobie przerwę lub podróżujesz na następne spotkanie? Wystarczy oznaczyć nową aktywność. Reszta zostanie zarejestrowana automatycznie.",
        change_teamleader: "Kończysz pracę, musisz wyjść lub nie masz już czasu dla zespołu? Po prostu oddaj urządzenie w aplikacji i wszystko wróci do normy.",
        clock_out: "Wystarczy jedno kliknięcie, aby Ty i Twój zespół zakończyli pracę. Oczywiście w dowolnym momencie można również wylogować poszczególnych członków zespołu.",
        thats_it: "Zrobiłeś to i jesteś gotowy do rejestrowania czasu pracy swojego zespołu. Jeśli potrzebujesz pomocy, po prostu skontaktuj się z nami. Z clockin wszystko jest proste - łącznie z komunikacją z nami."
      },
      button: {
        your_time_matters: "Pokaż mi, jak to się robi",
        thats_it: "Rozpocznij teraz"
      }
    },
    my_area: {
      heading: {
        welcome: "Witamy w Twojej okolicy",
        my_area: "Mój obszar",
        create_time: "Tworzenie czasu",
        change_time: "Prawidłowy czas",
        absences: "Nieobecności i wnioski",
        settings: "Ustawienia osobiste",
        thats_it: "To wszystko!"
      },
      text: {
        welcome: "Odkryj jeszcze więcej sposobów na efektywne i łatwe zarządzanie czasem pracy. Przyjrzyjmy się Twojemu obszarowi.",
        my_area: "Centralne miejsce, w którym masz natychmiastowy przegląd swoich godzin pracy i nadgodzin. Z tego miejsca można zarządzać godzinami pracy, uzyskać dostęp do dziennika, przesyłać wnioski i przeglądać swój czas pracy.",
        create_time: "Zapomniałeś wprowadzić czas lub chcesz dodać go później? Nie ma problemu! Dodawaj brakujące godziny, rejestruj przerwy i aktualizuj swoje konto czasu pracy.",
        change_time: "Chcesz poprawić swoje czasy? Nie ma problemu! Dzięki funkcji clockin możesz łatwo poprawiać i dostosowywać nieprawidłowe czasy.",
        absences: "Zarządzaj wnioskami urlopowymi, dniami chorobowymi i innymi nieobecnościami. Zawsze śledź status swoich wniosków i przesyłaj nowe szybko i łatwo za pomocą kilku kliknięć.",
        settings: "Wysyłaj wiadomości do firmy lub zmieniaj ustawienia osobiste, a jeśli chcesz zmienić hasło, możesz to zrobić również tutaj!",
        thats_it: "Udało się! Teraz możesz bez wysiłku zarządzać swoim czasem, organizować nieobecności i koncentrować się na tym, co ważne: swojej pracy. Powodzenia w produktywnym spędzaniu czasu!"
      },
      button: {
        welcome: "Pokaż mi, jak to się robi",
        thats_it: "Rozpocznij teraz"
      }
    },
    clock: {
      clockin_now: "Zablokuj teraz",
      clock_your_first_time_now: "i nagraj swój pierwszy raz"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Dziękujemy za korzystanie z clockin!",
      question: "Jak prawdopodobne jest, że polecisz clockin znajomym lub współpracownikom?",
      very_likely: "Bardzo prawdopodobne",
      very_unlikely: "Bardzo mało prawdopodobne",
      help_us_improve: "W jaki sposób możemy usprawnić logowanie?",
      what_do_you_agree_with: "Z którymi stwierdzeniami byś się zgodził?",
      choose_three_statements: "Wybierz maksymalnie trzy stwierdzenia.",
      hard_to_use: "Trudna obsługa",
      lacking_features: "Zbyt mało funkcji",
      does_not_help_me: "nie ułatwia mi dnia pracy",
      confusing: "mylący",
      poorly_implemented: "Słabo zaimplementowane funkcje",
      too_buggy: "zbyt podatny na błędy",
      too_slow: "długi czas ładowania",
      what_else: "Czy jest coś jeszcze, co chciałbyś nam powiedzieć?",
      can_we_ask_you_a_few_questions: "Czy możemy zadać jeszcze kilka pytań?",
      how_happy_are_you_with_the_introduction_of_clockin: "Jak bardzo jesteś zadowolony z wprowadzenia clockin w swojej firmie?",
      how_much_do_you_enjoy_using_clockin: "Jak ci się podoba korzystanie z clockin?",
      how_much_easier_does_clockin_make_your_work: "W jakim stopniu włączanie budzika ułatwia codzienną pracę?",
      how_happy_are_you_with_the_following_aspects: "W jakim stopniu jesteś zadowolony z poniższych punktów?",
      clarity_of_the_app: "Przejrzystość aplikacji",
      simplicity_of_use: "Prostota obsługi",
      app_features: "Funkcje w aplikacji",
      feedback_received: "Otrzymaliśmy Twoją opinię. Dziękujemy za poświęcony czas.",
      thanks_for_taking_the_time: "Dziękujemy za poświęcony czas.",
      what_can_we_do_to_improve: "Czy możesz opowiedzieć nam więcej o swoich doświadczeniach, abyśmy następnym razem mogli zrobić to jeszcze lepiej?",
      what_can_we_do_to_get_it_right: "Czy możesz opowiedzieć nam więcej o swoich doświadczeniach, abyśmy mogli następnym razem zrobić to dobrze?",
      comment_placeholder: "Twoja wiadomość"
    }
  },
  travel_logs: {
    add: "Dodaj szczegóły podróży",
    edit: "Edytuj szczegóły podróży",
    saving: "Szczegóły podróży są zapisywane...",
    saved_successfully: "Szczegóły podróży zostały pomyślnie zapisane!",
    unable_to_save: "Niestety to się nie udało 😢"
  },
  attach_file: "Załącz plik",
  image_to_text: {
    info: "Upewnij się, że tekst jest wyraźnie rozpoznawalny i widoczny w całości na obrazie.",
    attach_image: "Dołącz zdjęcie",
    processing: "Twój tekst zostanie wczytany.",
    processing_failed: "Niestety import nie zadziałał 😢",
    no_text_found: "Nie udało się rozpoznać żadnego tekstu."
  },
  correction_enter_reason: "Proszę podać powód korekty.",
  daily_notes: {
    add: "Napisz notatkę",
    edit: "Uwaga do edycji",
    saving: "Uwaga została zapisana...",
    saved_successfully: "Notatka została pomyślnie zapisana!",
    unable_to_save: "Niestety to się nie udało 😢",
    no_notes_yet: "Nie utworzono żadnej notatki",
    create_note: "Utwórz"
  },
  calendar_sync: {
    title: "Synchronizuj harmonogram",
    description: "Zsynchronizuj swój harmonogram pracy z kalendarzem i miej oko na stare i nowe spotkania.",
    url: "Adres w formacie iCal",
    url_description: "Możesz użyć tego adresu, aby uzyskać dostęp do tego kalendarza z innych aplikacji.",
    note: "Uwaga",
    note_description: "W przypadku niektórych kalendarzy wyświetlenie nowych spotkań może zająć do 24 godzin.",
    sync_now: "Synchronizacja kalendarza",
    copied: "Adres URL kalendarza został skopiowany."
  },
  registration: {
    skip_all: "Pomiń wszystko",
    already_signed_up: "Mam już konto",
    title_1: "Zaczynamy! Które godziny chciałbyś nagrywać za pomocą clockin?",
    description_1: "Pozwól nam dostosować zegar dla Ciebie",
    option_1_a: "Ogólny czas pracy (przyjście, wyjście i przerwa)",
    option_1_b: "Godziny pracy projektu",
    title_2: "Chcesz to udokumentować?",
    description_2: "Jakie wymagania należy w tym celu spełnić?",
    option_2_a: "Zdjęcia",
    option_2_b: "Szkice",
    option_2_c: "Funkcja uwagi",
    option_2_d: "Listy kontrolne i formularze",
    option_2_e: "Cyfrowe pliki projektu",
    title_3: "Co jeszcze chciałbyś zdigitalizować?",
    description_3: "W clockin jest o wiele więcej do odkrycia, może znajdziesz coś dla siebie.",
    option_3_a: "Wakacje",
    option_3_b: "Choroby i nieobecności",
    option_3_c: "Cyfrowe akta osobowe",
    option_3_d: "Analiza spółki",
    option_3_e: "Planowanie rozmieszczenia",
    option_3_f: "Konsultant ds. podatku od transferu danych (DATEV)",
    title_4: "W jakiej branży działa Twoja firma?",
    description_4: "Chcemy Cię lepiej poznać, abyśmy mogli lepiej dostosować clockin do Twoich potrzeb.",
    option_4_a: "usługi",
    option_4_b: "Rzemiosło",
    option_4_c: "Zdrowie i dobre samopoczucie",
    option_4_d: "Zakupy, zamówienia i handel",
    option_4_e: "Hotel i gastronomia",
    option_4_f: "Samochody, transport i maszyny",
    option_4_g: "Inny przemysł",
    title_5: "Ilu pracowników zatrudnia Twoja firma?",
    description_5: "Liczbę pracowników możemy dostosować do wielkości firmy.",
    title_6: "Super! Zegar jest już skonfigurowany",
    description_6: "Potrzebujemy tylko twojego imienia.",
    input_6_a: 'Firma',
    input_6_b: "Imię i nazwisko",
    input_6_c: "Nazwisko",
    input_6_d: "Numer telefonu",
    title_7: "Jesteś gotowy do pracy! Wypróbuj clockin 14 dni za darmo!",
    input_7_a: "Twój adres e-mail",
    description_7: "Na jaki adres e-mail należy wysłać hasło?",
    input_7_b: "W ten sposób stałem się świadomy",
    how_did_you_hear_about_clockin: "Jak dowiedziałeś się o clockin?",
    recommendation_option_1: "Zalecenie",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Wyszukiwanie w Internecie",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Platforma porównawcza",
    recommendation_option_7: "Artykuły w czasopismach i online",
    known_from: "Znany z",
    agb_1: "Przesyłając formularz, użytkownik akceptuje ",
    agb_2: 'AGB',
    agb_3: " i ",
    agb_4: "Polityka prywatności",
    start: "Rozpocznij test",
    validation_failed: "Prosimy o poprawne wypełnienie wszystkich pól."
  },
  clocki: {
    listening_heading: "Słucham cię",
    listening_subtext: "Jak mogę Ci pomóc?",
    hi_0: "Witam, w czym mogę pomóc?",
    hi_1: "Hej, w czym mogę pomóc?",
    hi_2: "Witam, w czym mogę pomóc?",
    hi_3: "Moin moin, co mogę dla ciebie zrobić?",
    hi_4: "Cześć, co mogę dla ciebie zrobić?",
    hi_5: "Witam, w czym mogę pomóc?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Niestety, rozpoznawanie głosu nie działa na Twoim urządzeniu",
    microphone_permission_denied: "Niestety nie mam dostępu do twojego mikrofonu. Sprawdź uprawnienia w ustawieniach, abym mógł Cię słyszeć.",
    please_speak: "Możesz teraz rozmawiać z Clockiem",
    create_activity: "Tworzenie działania",
    modify_activity: "Zmień aktywność",
    delete_activity: "Usuwanie aktywności",
    create_daily_note: "Utwórz codzienną notatkę",
    search_project: "Wyszukiwanie projektu",
    note_copied: "Skopiowano notatkę",
    create_absence_request: "Prośba o nieobecność",
    delete_absence: "Usuń nieobecność",
    confirm_deletion: "Czy jesteś pewien, że Twój {activity_label} Tłoczenie od {date} zegar powinien zostać usunięty?",
    confirm_absence_deletion: "Czy jesteś pewien, że Twoja prośba o {category} z {startDate} aż do {endDate} Chcesz usunąć?",
    task_before_modification: "Przed: {task}",
    starts_at_before_modification: "Czas rozpoczęcia przed: {startsAt}",
    ends_at_before_modification: "Czas zakończenia przed: {endsAt}",
    something_went_wrong: "Coś poszło nie tak, spróbuj ponownie później.",
    was_this_helpful: "Czy Clocki może Ci pomóc?",
    actions: {
      CREATE_ABSENCE: {
        title: "Potwierdzenie nieobecności"
      },
      CREATE_DAILY_NOTE: {
        title: "Utwórz notatkę teraz",
        daily_notes_disabled: "Niestety funkcja notatek jest nieaktywna. Poproś administratora o aktywację tej funkcji w centrum biurowym.",
        success: "Notatka została pomyślnie zapisana w dzienniku 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Utwórz dokumentację już teraz",
        created_by_clocki: "Utworzony za pomocą Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Otwórz teraz \"Moje czasy\""
      },
      REDIRECT_TO_MY_AREA: {
        title: "Otwórz teraz \"Mój obszar\""
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Otwórz teraz \"Zmień hasło\""
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Znaczek \"czas pracy\" teraz",
        PAUSE: "Naciśnij teraz przycisk \"Pauza\"",
        DRIVING_TIME: "Znaczek \"czas podróży\" teraz",
        LOGOUT: "Odblokuj teraz"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Czy lubisz korzystać z Clockin?"
  },
  translation_failed: "Niestety, tłumaczenie nie wyszło 😕",
  video_transcript_not_available: "Brak dostępnej transkrypcji",
  video_upload_succeeded: "Przesłanie wideo zakończone.",
  video_upload_failed: "Przesyłanie wideo nie powiodło się.",
  video_send_failed: "Wideo nie mogło być obecnie wyemitowane. Spróbujemy później ponownie.",
  uploading_video: "Przesyłam wideo...",
  language_selection_header: "Wybierz język",
  language_selection_message: "Wybierz preferowany język",
  shifts: {
    my_shifts: "Moje zmiany",
    free_shifts: "Wolne zmiany",
    next_shift: "Następna zmiana",
    shift_not_found: "Brak znalezionych warstw",
    show_shift_plan: "Zobacz ten harmonogram zmian",
    no_shift_place: "Nie podano lokalizacji",
    no_shifts_assigned: "Obecnie nie jesteś przypisany do żadnej zmiany",
    free_shifts_unavailable: "Obecnie nie dostępne są darmowe zmiany",
    filter_shift_plans: "Harmonogramy zmian filtrów",
    no_shift_plans_available: "Brak dostępnych grafików zmian",
    filter_locations: "Miejsca filtrów",
    no_locations_available: "Brak wolnych miejsc",
    no_plan_selected: "Nie wybrał żadnego harmonogramu zmian",
    no_shifts_for_plan: "Nie znaleziono warstw dla tego planu",
    no_shifts_for_location: "Nie znaleziono zmian dla wybranej lokalizacji",
    unknown_shift_plan: "Nieznany harmonogram zmian",
    unknown_location: "Nieznana lokalizacja",
    loading_more_shifts: "Załaduj więcej warstw..."
  },
  clockin_reminder_title: "Już w pracy? 🔔",
  clockin_reminder: "Pamiętaj, żeby się zameldować.",
  clockout_reminder_title: "Czy już jesteś na końcu dnia? 🔔",
  clockout_reminder: "Nie zapomnij się wylogować.",
  choose_clockin_reminder_time: "Czas przypomnienia o rejestracji",
  choose_clockout_reminder_time: "Przypomnienie o czasie wyjazdu",
  choose_break_reminder_time: "Czas pauzy",
  saved_successfully: "Pomyślnie uratowane 👍",
  clock_reminder_channel_name: "Przypomnienia o znaczkach",
  clock_reminder_channel_description: "Przypomnienia o rejestracji i wychodzeniu",
  break_reminder_title: "Wciąż robisz sobie przerwę? ⏰",
  break_reminder: "Uwaga: Czas przerwy nadal trwa.",
  // Video component translations
  video_not_supported: "Twoje urządzenie nie obsługuje tego wideo :/",
  video_loading_error: "Błąd ładowania wideo",
  video_retry: "Przeładowanie"
};